import { AbstractForm } from '../../utils/abstract-form';
import { FormBuilder } from '@angular/forms';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AdService } from '../../services/ad.service';
import { GeneralService } from '../../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from '../../services/snackbar.service';
import { AddressService } from '../../services/address.service';
import { State } from '../../models/state';
import { distinctUntilChanged, filter, debounceTime } from 'rxjs/operators';
import { GotoAction } from '../../models/action';
import { OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppLoadingService } from '../../services/apploading.service';
import { DialogActionComponent } from '../dialog-action/dialog-action.component';
import { MatDialog } from '@angular/material/dialog';

declare var $:any;

export abstract class AdController extends AbstractForm implements OnDestroy, AfterViewInit {

  saving: boolean = false;

  perfilId = null;
  adType = '';
  ad: any = 0;
  ad_category_id: any = 0;
  owner_person_id:any = null;
  currentStatus;

  conditionType: any[] = [];
  unitStatus: any[] = [];
  unitTypeDetail: any[] = [];
  typesType: any[] = [];

  isNew = false;

  formClassControl = null;
  formDisabled = false;

  states : any[] = [];

  status = '';

  artsDS: any = [];
  
  address: string;
  addressGeoLocation: any = {};
  addressGeoLocationLat: number = 0;
  addressGeoLocationLng: number = 0;
  private addressChanges:Subscription;

  adFiles : any = [];
  adVideos : any = [];
  adDocuments : any = [];
  adProgress : any = [];
  adPromotionRealtor : any = [];
  adPromotionClient : any = [];
  adAuthorization : any = [];

  checkboxGroups : any = [];
  subscribesFields : any = [];

  maxUnit = 0;
  unitsByFloor = [];
  unitsByBlock = [];

  typeSettingsDefine:any = {};
  typeSettingsDefineSel:any = {};

  blocksDS: any[] = [];
  unitTypesDS: any[] = [];
  unitsDS: any[] = [];
  expensesDS: any[] = [];


  generalDataSubscription:Subscription;
  settingsLoadSubscription:Subscription;

  constructor(protected formBuilder: FormBuilder,
    protected logger: LoggerService,
    protected adService: AdService,
    protected gs: GeneralService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected snackBarService: SnackBarService,
    protected addressService: AddressService,
    protected als : AppLoadingService,
    public dialog: MatDialog
  ) {
    super(formBuilder,logger, false);  

    this.adType = this.activatedRoute.snapshot.paramMap.get('type');
    this.ad = this.activatedRoute.snapshot.paramMap.get('id');
    this.ad_category_id = this.activatedRoute.snapshot.paramMap.get('category_id');
    this.owner_person_id = this.activatedRoute.snapshot.paramMap.get('owner_person_id');

  }

  abstract setDefault(): any;

  ngOnInit(){
    this.settingsLoadSubscription = this.gs.settingsLoad$.subscribe(result => {
      this.states = result.states;
    });

    this.generalDataSubscription = this.gs.generalData$.subscribe(result => {
      this.typesType = this.gs.getTags('unitType', this.adType);
      this.unitTypeDetail = this.gs.getTags('unitTypeDetail', this.adType);
      this.unitStatus = this.gs.getStatus('unit', this.adType);
      this.conditionType = this.gs.getTags('conditionType', this.adType)?.sort((a,b) => a?.attr?.sort - b?.attr?.sort);
      if(!!result?.person?.length)
        this.perfilId = result?.person[0]?.perfil_id || null;
        
      this.setDefault();
    });
  }
  ngAfterViewInit(){
    this.als.setLoaded(false,this.gs.getBase()+'AdLoad');
    if(this.ad !== 0 && this.ad != null){
      this.loading = true;
      
      this.adService.loadAd(this.ad, this.gs.getCompanieSel() || this.owner_person_id)
        .then(() => this.adService.getAd(this.ad, true))
        .catch((err) => this.gs.error(err))
        .finally(()=> this.afterLoad());
    } else {
      this.adService.newAd();
      this.afterLoad();
    }
    
  }

  getModule(){
    return this.gs.getModule();
  }


  abstract subscribeOnChangeExtra();
  abstract load(refresh:boolean);

  afterLoad(){

    this.isNew = !this.adService?.adDataOpen?.ad_id;
    this.currentStatus = this.adService?.adDataOpen?.status;

    this.formDefault();
    this.load(false);
    this.endLoading();
    this.als.setLoaded(true,this.gs.getBase()+'AdLoad');
    $('[data-toggle="tooltip"]').tooltip({
      trigger : 'hover'
    });
  }

  ngOnDestroy(){
    this.adService.setAdOpen(false);
    this.adService.setAction(null);
    this.generalDataSubscription?.unsubscribe();
    this.settingsLoadSubscription?.unsubscribe();
  }

  updateControlsAddress(init = false){
    if(!this.getControl('addressZipcode'))
      return;

    if(init)
      this.setControlValue('addressZipcode',this.adService.adDataOpen.data.address.zipcode, this.formGroup, {emitEvent:false});

    this.setControlValue('addressState',State.getStateByCode(this.states, this.adService.adDataOpen.data.address.stateId), this.formGroup, {emitEvent:false});
    this.setControlValue('addressCityId',this.adService.adDataOpen.data.address.cityId, this.formGroup, {emitEvent:false});
    this.setControlValue('addressCity',this.adService.adDataOpen.data.address.city, this.formGroup, {emitEvent:false});
    this.setControlValue('addressDistrict',this.adService.adDataOpen.data.address.district, this.formGroup, {emitEvent:false});
    this.setControlValue('addressStreet',this.adService.adDataOpen.data.address.street, this.formGroup, {emitEvent:false});
    this.setControlValue('addressComplement',this.adService.adDataOpen.data.address.complement, this.formGroup, {emitEvent:false});
    this.setControlValue('addressNumber',this.adService.adDataOpen.data.address.number, this.formGroup, {emitEvent:false});
    this.setControlValue('addressDescription',this.adService.adDataOpen.data.address.description, this.formGroup, {emitEvent:false});
    this.setControlValue('addressExact',this.adService.adDataOpen.data.address.exact, this.formGroup, {emitEvent:false});

    this.addressGeoLocationLng = this.adService.adDataOpen.data.address.longitude;
    this.addressGeoLocationLat = this.adService.adDataOpen.data.address.latitude;

    this.getControl('addressGeoLocationLng').markAsDirty();
    this.getControl('addressGeoLocationLat').markAsDirty();
  }

  updateObjectAddress(): any {
    if(!this.getControl('addressZipcode'))
      return {};

    return {
      zipcode : this.validateNull(this.getControlValue('addressZipcode')),
      countryId : this.getControlValue('addressState')?.country_id ?? null,
      state : this.getControlValue('addressState')?.state_name ?? null,
      stateId : this.getControlValue('addressState')?.state_id ?? null,
      country : this.validateNull('Brazil'),
      cityId : this.getControlValue('addressCityId') === null? null : this.getControlValue('addressCityId'),
      city : this.validateNull(this.getControlValue('addressCity')),
      district : this.validateNull(this.getControlValue('addressDistrict')),
      street : this.validateNull(this.getControlValue('addressStreet')),
      complement : this.validateNull(this.getControlValue('addressComplement')),
      number : this.validateNull(this.getControlValue('addressNumber')),
      description : this.validateNull(this.getControlValue('addressDescription')),
      location : {lon: this.addressGeoLocationLng, lat:this.addressGeoLocationLat},
      exact : this.getControlValue('addressExact'),
    };
  }  

  getTags(area, type, id = false, column = null){
    let tags = this.gs.getTags(area, type, id, column);
    
    if(!tags.length)
      return [];

    return tags.sort((a,b) => (a.tag > b.tag) ? 1 : ((b.tag > a.tag) ? -1 : 0));
  }

  actionController(action){
      if(action == null)
        return;

      switch(action){
        case 'back':
          this.back();
        break;
        case 'delete':
          const dialogRef = this.dialog.open(DialogActionComponent, 
            {disableClose : true,
             data: {
                title:'Realmente deseja excluir?',
                cancelTitle:'Não',
                okTitle:'Sim desejo'
            }});

          dialogRef.afterClosed().subscribe(result => {
            if(result)
              this.save(action, null);
          });
          
        break;
        case 'authorize':
          const dialogRef2 = this.dialog.open(DialogActionComponent, 
            {disableClose : true,
             data: {
                title:'Deseja notificar o anunciante?',
                cancelTitle:'Não',
                okTitle:'Sim'
            }});

          dialogRef2.afterClosed().subscribe(result => {
              this.save(action,null,null, result? true : false);
          });
        break;
        default:
          this.save(action, null);
        break;
      }  
  }

  saveComplete(action, id){
    let doBack = this.adService.getActionToBack(action);

    if(doBack)
      this.goBack();
    else {
      if(this.isNew){
        this.isNew = false;
        this.gs.navigate([this.gs.getModule(),'ad',this.adType,this.ad_category_id,id, this.owner_person_id]);
      } else
        this.reload(id);
    }

  }

  goBack(){
    return new GotoAction(null, '', [this.gs.getModule(),'ad'], { skipLocationChange: true }, this.router).execute();
  }

  reload(id){
    this.loading = true;

    this.unsubscribeOnChange();
    
    this.als.setLoaded(false,this.gs.getBase()+'/AdLoad');
    
    this.adService.loadAd(id, this.gs.getCompanieSel() || this.owner_person_id)
      .then( item => {
        this.adService.getAd(id, true);
        this.load(true);
      })
      .catch(this.gs.error)
      .finally(()=>{
        this.als.setLoaded(true,this.gs.getBase()+'/AdLoad');
        this.endLoading();
      });
  }

  back(){

    let changedProperties = [];

    Object.keys(this.formGroup.controls).forEach((name) => {
      let currentControl = this.formGroup.controls[name];

      if (currentControl.dirty)
        changedProperties.push(name);
    });

    if (!this.formGroup.dirty) {
      this.goBack();
      return ;
    }

    this.snackBarService.open('Cadastro não concluído, deseja cancelar?', 'Sim')
      .onAction().subscribe(() => {
        this.goBack();
      });
  }

  save(action, data, then:any = null, notify:boolean = false): Promise<any>{

    var data = data || this.updateObject();
        data.notify = notify;

    this.als.setLoaded(false,this.gs.getBase()+'/AdSaving');
    this.saving = true;

    let th = this;

    return this.adService.executeAction(action, data, 
      then || function(value: any){ //then
        if(value){
          th.ad = value;
          //th.isNew = false;
        }
        
        th.checkboxUntouched();

        if(data?.ad_id)
          th.ad = data.ad_id;

        th.owner_person_id = data.owner_person_id;
        th.saveComplete(action, value? value : data.ad_id);
        switch(action){
          case 'delete':
            th.snackBarService.open('Excluído com sucesso');
          break;
          default:
            th.snackBarService.open('Salvo com sucesso');
          break;
        }
        Promise.resolve(value);
      },
      function(error){
        th.gs.error(error,'Ocorreu um erro ao salvar');
      },
      function(){ //finally
        th.saving = false;
        th.als.setLoaded(true,th.gs.getBase()+'/AdSaving');
      });
  }

  zipcodeIsValid(){
    return this.getControl('addressZipcode').value == null? false : this.getControl('addressZipcode').value.replace('-', '').replace('.', '').length == 8;
  }

  getTagId(controlName){
    let controlValue = this.getControlValue(controlName);
    let arr = [];
    if (Array.isArray(controlValue)) {
      controlValue.forEach((item: any) => {
            if (item.tag_id != null) {
              arr.push({tag_id : item.tag_id});
            }
        });
    }
    return arr;
  }

  validateNull(str){
    return (str === null || str === undefined || (typeof str =='string' && !str.trim().length))? null : str;
  }

  subscribeOnChange() {
    if(!this.getControl('addressZipcode'))
      return;

    this.addressChanges = this.getControl('addressZipcode').valueChanges
      .pipe(
        filter(text => typeof text ==='string' && text.replace('-', '').replace('.', '').length == 8),
        debounceTime(350),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.gs.findCep(value)
          .then(value => {
            let data = value[0] || value;
            if(this.adService.adDataOpen.data.address == undefined)
              this.adService.adDataOpen.data.address = {};

            this.adService.adDataOpen.data.address.cityId = data?.city_id;
            this.adService.adDataOpen.data.address.city = data?.city_name;
            this.adService.adDataOpen.data.address.zipcode = data?.zipcode;
            this.adService.adDataOpen.data.address.stateId = data?.state_id;
            this.adService.adDataOpen.data.address.state = State.getStateByCode(this.states, data?.state_id);
            
            if(data?.district !== null)
              this.adService.adDataOpen.data.address.district = data?.district;

            if(data?.street !== null)
              this.adService.adDataOpen.data.address.street = data?.street;

            this.updateControlsAddress(false);
            this.updateMap();
          })
          .catch(error => {
            this.logger.error('Não carregou a cidade', error);
          });
      });

    ['addressState','addressStreet','addressCityId','addressCity','addressDistrict','addressComplement','addressNumber'].forEach(item => {
      this.subscribesFields.push(this.getControl(item).valueChanges
        .pipe(
          debounceTime(350),
          distinctUntilChanged(),
        ).subscribe(value => this.updateMap(value,item))
      );
    });
    this.subscribeOnChangeExtra();
  }

  unsubscribeOnChange() {
    this.addressChanges?.unsubscribe();
    this.subscribesFields.map(item => item?.unsubscribe());
    this.subscribesFields = [];
  }

  updateMap(value = false, item : any = false){
    this.addressGeoLocation = this.updateObjectAddress();
  }

  addressUpdate(event){
    this.addressGeoLocationLat = event.lat;
    this.addressGeoLocationLng = event.lng;

    if(typeof event.user != 'undefined'){
      this.getControl('addressGeoLocationLng').markAsDirty();
      this.getControl('addressGeoLocationLat').markAsDirty();
    }
  }

  normalizeArray(list){
    if(list instanceof Array)
      list = list.reduce(function(result, item) {
        result[item] = '';
        return result;
      }, {});
    
    return list;

  }

  checkboxChange(group, id = null, checked = null){

    if(this.checkboxGroups.indexOf(group) == -1)
      this.checkboxGroups.push(group);

    let list = this.getControlValue(group);
    if(!list)
      list = {};

    list = this.normalizeArray(list);

    if(id!=null && checked!=null){
      
      if(checked)
        list[id] = '';
      else 
        delete list[id];
    }

    this.getControl(group).setValue(list);
    this.getControl(group).markAsDirty();

  }

  checkboxUntouched(){
    this.checkboxGroups.forEach(item => this.getControl(item).markAsPristine() );
  }

  checkboxDescription(event, group, id){
    let list = this.getControlValue(group);

    if(!list || !event?.target?.value)
      return false;

    list = this.normalizeArray(list);

    list[id] = event?.target?.value;

    this.getControl(group).setValue(list);
    this.getControl(group).markAsDirty();

    return list[id];
  }

  checkboxIsChecked(group, id){
    let list = this.getControlValue(group);
    if(!list)
      return false;

    list = this.normalizeArray(list);
    
    return list[id] != undefined;
  }

  getCheckboxDescription(event, group, id){
    let list = this.getControlValue(group);

    if(!list)
      return '';

    list = this.normalizeArray(list);

    return list[id] || '';
  }

  getStatus(num : Boolean = false){

    let isAdmin = this.gs.getModule().indexOf('admin') > -1;

    if(this.adService.adDataOpen.status == 0)
      return num? 0 : "Novo";

    var status = this.adService.adDataOpen.status == 0? "1" : this.adService.adDataOpen.status;
        status = isAdmin? status : (status > 2? 5 : status);

    return num? parseInt(status) : this.adService.getStatus(status);

  }

  hasClass(element, styleClass, parent = false){
    if(element == null)
      return false;

    var has = element.classList.contains(styleClass);
    
    if(has || !parent)
      return has;

    return this.hasClass(element.parentElement, styleClass, parent);
  }

  compareFnTag(c1: any, c2: any): boolean {

    if(c2 === null)
      return false;
      
    if(typeof c1 == 'object' && typeof c1 == typeof c2)
      return (c1?.tag_id && c2?.tag_id && c1?.tag_id == c2?.tag_id) || (c1?.id && c2?.id && c1?.id == c2?.id);
    else 
      return c1?.tag_id == c2 || c1 == c2?.tag_id || c1 == c2;
  }

  compareFnCategory(c1: any, c2: any): boolean {
    if(c2 === null)
      return false;

    return c1?.attr?.category_id == c2?.attr?.category_id || c1?.attr?.category_id == c2 || c1 == c2?.attr?.category_id;
  }
  compareFn(c1: any, c2: any): boolean {
    if(c2 === null)
      return false;

    return c1 == c2;
  }

  compareFnBlockType(c1: any, c2: any): boolean {
    if(c2 === null)
      return false;

    return c1?.id == c2 || c1 == c2?.id;

  }

  compareFnState(c1: any, c2: any): boolean {
    if(c2 === null)
      return false;

    return c1.state_id == c2.state_id || c1.state_id == c2;
  }

  protected mergeData(newData,dataSource){
    for(var k in newData)
      if (newData.hasOwnProperty(k)){
        var kk = this.lookupValueByKey(dataSource,newData[k].id,'id','key');
        if(kk==null)
          dataSource.push(newData[k]);
        else
          dataSource[kk] = newData[k];
      }

    return dataSource;
  }

  extractValues(mappings,first = []) {
    var arr = first;
    for(var k in mappings)
      if (mappings.hasOwnProperty(k))
        arr.push(mappings[k]);
  
    return arr;
  }

  lookupValue(mappings, key) {
    return typeof mappings === 'undefined' || typeof mappings[key] ==='undefined'? null : mappings[key];
  }

  lookupKey(mappings, name) {
    for (var key in mappings) {
      if (mappings.hasOwnProperty(key)) {
        if (name === mappings[key]) {
          return key;
        }
      }
    }
  }

  extractValuesByKey(mappings,key,first = []) {
    var arr = first;
    for(var k in mappings)
      if (mappings.hasOwnProperty(k))
        arr.push(parseInt(mappings[k][key]));
    
    return arr;
  }

  lookupValueByKey(mappings, key, fK, fV) {
    if(typeof key ==='undefined')
      return null;

    var mapKey = null;
    var m = mappings.filter(function(item,mk){

      var cond = typeof item[fK] !== 'undefined' && item[fK].toString() == key.toString();

      if(cond)
        mapKey = mk;

      return cond;
    })[0];

    if(fV =='key')
      return mapKey;
    
    if(typeof m ==='undefined')
      return null;

    return (typeof fV === 'undefined' || fV === false? m : m[fV]);
    
  }


  getRoomText(data){
    let txt = '';
    if(data.suite==0 || data.room!=data.suite)
      txt+=data.room;

    if(data.suite>0){
      if(data.room != data.suite)
        txt += ' sendo ';
      txt += data.suite + ' suíte'+(data.suite > 1? 's': '');
    }
    
    return txt;
  }


  getUnitTypesByBlockId(blockId, key: any = false) {
    var r = [];

    if (!this.unitTypesDS.length)
      return r;

    var ids = this.unitTypesDS.filter(item => item['blockId'] == blockId);

    for (var k in ids)
      if (ids.hasOwnProperty(k))
        r.push(key === false ? ids[k] : ids[k][key]);

    return r;
  }

  getUnitsRowData(blockId) {

    var unitTypes = this.getUnitTypesByBlockId(blockId, 'id');
    return this.unitsDS.filter(item => unitTypes.indexOf(parseInt(item['blockTypeId'])) > -1);
  }  

  getTypeById(typeId){
    return this.unitTypesDS.filter(item => item.id == typeId)[0];
  }


  setUnitsByFloor(){
    this.unitsByFloor = []; 
    this.unitsByBlock = []; 
    this.blocksDS.map(block => {
      let units = JSON.parse(JSON.stringify(this.getUnitsRowData(block.id)));
      let floorStart = 1;
      let nu = [];
      this.unitsByBlock[block.id] = [];
      units.map(unit => {
        let numc = unit.unitNum = unit.title.replace(/\D/g,'') || '0';
        
          let start = parseInt(numc.substr(0,numc.length - 2));
          if(isNaN(start))
            start = 0;

          this.unitsByBlock[block.id].push(unit);
          
          let floor = (floorStart + start - 1);
          if(typeof nu[floor] == 'undefined')
            nu[floor] = {floor : floor, units : []};
          
          if(typeof nu[floor] != 'undefined'){
            unit.unitType = this.getTypeById(unit.blockTypeId);

            if(!nu[floor].units.filter(u => u.unitNum == unit.unitNum && u.id!='empty')?.length){
              nu[floor].units = nu[floor].units.filter(u => u.unitNum != unit.unitNum);
              nu[floor].units.push(unit);
            }

            nu[floor].units.sort((a,b) => a?.unitNum - b?.unitNum);

            let nEmpS = parseInt(floor + Array(nu[floor]?.units[0].unitNum?.length-floor?.toString().length).join("0") + '1');
            let nEmpE = parseInt(nu[floor]?.units[nu[floor]?.units?.length-1].unitNum);
            
            if(nu[floor]?.units.length < nEmpE - nEmpS +1){
              for(let p = nEmpS, i = 0; p <= nEmpE; p++, i++){
                if(!nu[floor]?.units.filter(u => parseInt(u.unitNum) == p)?.length)
                  nu[floor].units.splice(i, 0, {id:'empty', unitNum: p.toString()});
              }
            }

            if(nu[floor].units.length > this.maxUnit)
                this.maxUnit = nu[floor].units.length;
          }
      });
      this.unitsByBlock[block.id] = this.unitsByBlock[block.id].sort((a,b) => a?.unitNum - b?.unitNum);
      this.unitsByFloor.push({
        id : block.id,
        units : nu.reverse().filter(Boolean)
      });
      
    });

  }

  async createBitLy(link, title, id = false){
    return await this.adService.createBitLy(link, title, id);
  }

  getArts(type){
    return this.artsDS.filter(item => item.type == type)[0] || {};

  }

  setArts(type, data:any = {}){
    console.log(type, data);

    if(!this.artsDS.filter(item => item.type == type)?.length){
      data.type = type;
      this.artsDS.push(data);
    } else
      this.artsDS = this.artsDS.map(item => {
        if(item.type == type)
          item = {...item,...data};
        return item;
      });
  }
 
}
